import React, {useEffect, useMemo, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {useLocation, useNavigate} from 'react-router-dom'
import CreateUserProfile from './CreateUserProfile'
import './OwnerStaffAccount.scss'
import ReactPaginate from 'react-paginate'
import moment from 'moment'
import axios from 'axios'
import {KTSVG} from '../../../../../_metronic/helpers'
import {UpdateStatusForOwner} from '../../../../Redux/AdminPanel/AssignUserSlice'

import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {DeleteTeamProfile, GetAllTeamList} from '../Overview/OverviewSlice/TeamListSlice'
import {
  GetAllStaff,
  GetAllStaffForStaffAdmin,
} from '../../../AdminPages/MyProfile/Staff_Account/StaffAccountSlice/StaffAccountSlice'
import {getUserData} from '../../../../modules/auth/components/Frontend_Auth_Components/UserLoginRedux/UserLoginSlice'
import {AuthenticateUser} from '../../../../Utils/_helpers/RoleAndPermission'
import {ProfileDetailData} from '../../../../Redux/AdminPanel/ProfileDetailsSlice'
import NodataYet from '../../../../Components/NodataYet'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'
import {toast} from 'react-toastify'
import {
  useGenererateInviteLinkMutation,
  useSendInviteLinkMutation,
} from '../../../../../services/cellcast'
import { MenuComponent } from '../../../../../_metronic/assets/ts/components'

const TeamList = () => {
  const API_URL = ENV().REACT_APP_API_URL
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const param = useLocation()

  const dispatch = useDispatch()
  const [subUser, setSubUser] = useState(false)
  // It for checking Role of user
  const user = useSelector(getUserData)?.data?.user?.role
  const OwnerId = useSelector(getUserData)?.data?.user?._id
  const Teamlist = useSelector((state: any) => state?.teamlist?.TeamList?.items)
  const Teams = useSelector((state: any) => state?.teamlist?.TeamList)
  const [checkList, setCheckList] = useState<any>([])
  const [open, setOpen] = useState(false)
  const [confirm, setConfirm] = useState<any>(false)
  const [deleteIds, setDeleteIds] = useState<any>()
  const [userData, setUserData] = useState<any>()
  const [generateInviteLink] = useGenererateInviteLinkMutation()
  const [sendInviteLink] = useSendInviteLinkMutation()
  const [page, setPage] = useState({
    page: 1,
    size: 10,
  })

  useEffect(() => {
    dispatch(GetAllTeamList({ownerId: OwnerId, page: page}))
  }, [])

  useEffect(() => {
    dispatch(GetAllTeamList({ownerId: OwnerId, page: page.page, size: page.size}))
  }, [page.page])

  useEffect(() => {
    dispatch(GetAllTeamList({ownerId: OwnerId, page: 1, size: page.size}))
  }, [page.size])

  useEffect(() => {
    if (param.pathname == '/accounts/staff-account') {
      if (user == 'superAdmin') {
        dispatch(
          GetAllStaff({
            page: page,
          })
        )
      }

      if (user == 'staffAdmin') {
        dispatch(
          GetAllStaffForStaffAdmin({
            page: page,
          })
        )
      }
    }
  }, [page.page])

  const handleCheckAll = () => {
    if (checkList?.length == Teamlist?.length) {
      setCheckList([])
    } else {
      let list = Teamlist?.map((key: any) => key._id)
      setCheckList([...list])
    }
  }

  const handleCheck = (e: any) => {
    if (checkList?.includes(e.target.value)) {
      checkList.splice(checkList?.indexOf(e.target.value), 1)

      setCheckList([...checkList])
    } else {
      setCheckList([...checkList, e.target.value])
    }
  }

  const handleEdit = (data: any) => {
    dispatch(ProfileDetailData(data?._id))
    setUserData({...data, editting: true})
    setSubUser(true)
  }

  //IF get confirmation from popup it will delete
  useEffect(() => {
    if (confirm == true) {
      dispatch(
        DeleteTeamProfile({
          userIds: deleteIds,
          page: page,
          ownerId: OwnerId,
        })
      )
      setCheckList([])
      setConfirm(false)
    }
  }, [confirm])

  const handleDeleteAll = () => {
    setOpen(true)
    setDeleteIds(checkList)
  }
  const handleDelete = (id: any) => {
    setOpen(true)
    setDeleteIds([id])
  }
  const popup = useMemo(
    () => (
      <CreateUserProfile
        filter={page}
        show={subUser}
        data={userData}
        setData={setUserData}
        handleClose={() => setSubUser(false)}
      />
    ),
    [subUser, userData]
  )
  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={open}
        handleClose={() => setOpen(false)}
        Message={'Are you sure, you want to delete user?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [open]
  )

  const handleExport = () => {
    axios
      .get(`${API_URL}user/getlistofSubAccount`, {
        params: {...page, export: true, exportArr: checkList?.join(',')},
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      })
      .then((res: any) => res && window.open(`${API_DOMAIN}${res.data.data.downloadurl}`, '_self'))
  }

  const UserRole: any = {
    FEuserAdmin: 'User Admin',
    FEmanager: 'Manager',
    FEauthor: 'Author',
    FEviewer: 'Viewer',
  }
  return (
    <>
      {confirmation}
      {popup}
      {
        <div className={`sub-accountstable card`}>
          <div className='card-header border-0 pt-5'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Users</span>
              <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
            </h3>
            <div className='card-toolbar  mb-1'>
              {checkList?.length > 0 && AuthenticateUser('delete-sub-account') && (
                <>
                  <div className='fw-bolder pe-8'>
                    <span className='me-2'>{checkList?.length}</span> Selected
                  </div>
                  <button type='button' className='btn btn-danger' onClick={handleDeleteAll}>
                    Delete Selected
                  </button>
                </>
              )}
            </div>
            <div
              className='card-toolbar'
              data-bs-toggle='tooltip'
              data-bs-placement='top'
              data-bs-trigger='hover'
              title='Click to add a user'
            >
              {AuthenticateUser('export-sub-accounts') && (
                <button
                  data-testid='btnExportUsers'
                  onClick={handleExport}
                  type='button'
                  className='btn btn-light-primary me-3'
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                  Export
                </button>
              )}

              {AuthenticateUser('create-sub-account') && (
                <button
                  data-testid='btnAddPerson'
                  type='button'
                  className='btn btn-primary'
                  onClick={() => {
                    setUserData({
                      avatar: '',
                      email: '',
                      mobile: '',
                      name: '',
                      role: '',
                      id: '',
                      editting: false,
                      isMobileVerified: false,
                      isEmailVerified: true,
                    })
                    setSubUser(true)
                  }}
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                  Add person
                </button>
              )}
            </div>
          </div>
          {Teamlist?.length > 0 ? (
            <div className='card-body py-3'>
              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bolder text-muted'>
                      <th className='w-25px'>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            value='1'
                            data-kt-check='true'
                            data-kt-check-target='.widget-9-check'
                            checked={checkList?.length == Teamlist?.length && checkList?.length > 0}
                            onChange={handleCheckAll}
                          />
                        </div>
                      </th>
                      <th className='min-w-150px'>USER</th>
                      <th className='min-w-140px'>ROLE</th>
                      <th className='min-w-120px'>LAST LOGIN</th>
                      <th className='min-w-120px  text-center'>Status</th>
                      <th className='min-w-120px  text-center'>Verified</th>
                      <th className='min-w-100px'>JOINED-DATE</th>
                      <th className='min-w-100px text-center'>ACTIONS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Teamlist?.map((data: any, i: number) => (
                      <tr key={i}>
                        <td>
                          <div className='form-check form-check-sm form-check-custom form-check-solid'>
                            <input
                              className='form-check-input widget-9-check'
                              type='checkbox'
                              value={data?._id}
                              checked={checkList?.includes(data?._id)}
                              onChange={handleCheck}
                            />
                          </div>
                        </td>
                        <td>
                          <div className='d-flex align-items-center cursor-pointer'>
                            <div
                              // onClick={() => navigate('/user-profile', {state: [data, 'user']})}
                              className='symbol symbol-45px me-5'
                            >
                              {data?.avatar && data?.avatar !== 'undefined' ? (
                                <img src={data?.avatar} alt='' />
                              ) : (
                                <span className='circle1'>{`${data?.firstName
                                  ?.split('')[0]
                                  ?.toUpperCase()}${
                                  data?.lastName !== undefined && data?.lastName !== ''
                                    ? data?.lastName?.split('')[0]?.toUpperCase()
                                    : ''
                                }`}</span>
                              )}
                            </div>
                            <div className='d-flex justify-content-start flex-column'>
                              <span className='text-dark fw-bolder text-hover-primary fs-6'>
                                {`${data?.firstName} ${data?.lastName}`}
                              </span>
                              <span className='text-muted fw-bold text-muted d-block fs-7'>
                                {data?.email}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span className='d-block fs-6' style={{color: '#838492'}}>
                            {UserRole?.[data?.role]}
                          </span>
                        </td>
                        <td className=' fs-6' style={{color: '#838492'}}>
                          {/* {`${Math.round(
                        moment().diff(moment(data?.lastLogin).format('DD/MM/YYYY'), 'months', true)
                      )} MONTHS AGO`} */}
                          {moment(data?.lastLogin).fromNow()}
                        </td>
                        <td className=' text-center'>
                          <a
                            href='#'
                            className={`'badge px-3 py-1 badge-light-${
                              data?.status2 == 'active'
                                ? 'success'
                                : data?.status2 == 'inactive'
                                ? 'warning'
                                : 'danger'
                            }`}
                          >
                            {data?.status2}
                          </a>
                        </td>
                        <td className=' text-center'>
                          <a
                            href='#'
                            className={`'badge px-3 py-1 badge-light-${
                              data?.status == 'verified' ? 'success' : 'danger'
                            }`}
                            style={{textTransform: 'capitalize'}}
                          >
                            {data?.status}
                          </a>
                        </td>

                        <td>
                          <span className='text-dark fw-bolder text-hover-primary d-block fs-6'>
                            {moment(data?.createdAt).format('DD/MM/YYYY')}
                          </span>
                        </td>

                        <td>
                          <div className='menu-item me-0'>
                            <span
                              className='btn btn-light btn-active-light-primary btn-sm'
                              data-kt-menu-trigger='hover'
                              data-kt-menu-placement='bottom-end'
                            >
                              Actions
                              <KTSVG
                                path='/media/icons/duotune/arrows/arr072.svg'
                                className='svg-icon-5 m-0'
                              />
                            </span>
                            <div
                              className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-200px py-4'
                              data-kt-menu='true'
                            >
                              <h5 className='dropdown_title'>Action</h5>
                              {/* begin::Menu item */}

                              {AuthenticateUser('edit-sub-account') && (
                                <div className='my-3'>
                                  <div className='menu-item px-3'>
                                    <OverlayTrigger
                                      placement='top'
                                      overlay={<Tooltip>Send Invite Link to user email</Tooltip>}
                                    >
                                      <span
                                        className='menu-link px-3'
                                        onClick={() => {
                                          sendInviteLink({email: data?.email})
                                            .then((res: any) => {
                                              toast.success('invite link has been sent')
                                            })
                                            .catch((err: any) => {
                                              toast.error(err.message)
                                            })
                                        }}
                                      >
                                        <i className='bi bi-send me-2'></i> Send Invite
                                      </span>
                                    </OverlayTrigger>
                                  </div>

                                  <div className='menu-item px-3'>
                                    <OverlayTrigger
                                      placement='top'
                                      overlay={<Tooltip>Copy Invite Link</Tooltip>}
                                    >
                                      <span
                                        className='menu-link px-3'
                                        onClick={() => {
                                          generateInviteLink({email: data?.email})
                                            .unwrap()
                                            .then((res: any) => {
                                              navigator.clipboard.writeText(
                                                res?.data?.invitationLink
                                              )
                                              toast.success('Copied!')
                                            })
                                            .catch((err: any) => {
                                              toast.error(err.message)
                                            })
                                        }}
                                      >
                                        <i className='bi bi-clipboard me-2'></i>Copy Invite Link
                                      </span>
                                    </OverlayTrigger>
                                  </div>
                                  <hr className='border border-gray-400 my-3' />
                                </div>
                              )}

                              {AuthenticateUser('edit-sub-account') && (
                                <div className='menu-item px-3'>
                                  <span
                                    className='menu-link px-3'
                                    onClick={() => {
                                      handleEdit(data)
                                    }}
                                  >
                                    Edit
                                  </span>
                                </div>
                              )}
                              {/* end::Menu item */}
                              {AuthenticateUser('edit-sub-account') && (
                                <div
                                  className='menu-item px-3'
                                  data-kt-menu-trigger='hover'
                                  data-kt-menu-placement='right-end'
                                >
                                  <span className='menu-link px-3'>
                                    <span className='menu-title'>Change Status</span>
                                    <span className='menu-arrow' />
                                  </span>
                                  <div className='menu-sub menu-sub-dropdown w-175px py-4'>
                                    <div
                                      className='menu-item px-3'
                                      onClick={() => {
                                        dispatch(
                                          UpdateStatusForOwner({
                                            userId: data?._id,
                                            status2: 'active',
                                          })
                                        )
                                      }}
                                    >
                                      <span className='menu-link px-3'>
                                        <span className='bg-success   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                        <span className='menu-title'>Active</span>
                                        {data?.status2 == 'active' && (
                                          <span className='svg-icon svg-icon-primary'>
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              xmlnsXlink='http://www.w3.org/1999/xlink'
                                              width='24px'
                                              height='24px'
                                              viewBox='0 0 24 24'
                                              version='1.1'
                                            >
                                              <g
                                                stroke='none'
                                                strokeWidth={1}
                                                fill='none'
                                                fillRule='evenodd'
                                              >
                                                <polygon points='0 0 24 0 24 24 0 24' />
                                                <path
                                                  d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                                  fill='#7950f2'
                                                  fillRule='nonzero'
                                                  transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                                />
                                              </g>
                                            </svg>
                                          </span>
                                        )}
                                      </span>
                                    </div>
                                    <div
                                      className='menu-item px-3'
                                      onClick={() => {
                                        dispatch(
                                          UpdateStatusForOwner({
                                            userId: data?._id,
                                            status2: 'inactive',
                                          })
                                        )
                                      }}
                                    >
                                      <span className='menu-link px-3'>
                                        <span className='bg-secondary   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                        <span className='menu-title'>Inactive</span>

                                        {data?.status2 == 'inactive' && (
                                          <span className='svg-icon svg-icon-primary'>
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              xmlnsXlink='http://www.w3.org/1999/xlink'
                                              width='24px'
                                              height='24px'
                                              viewBox='0 0 24 24'
                                              version='1.1'
                                            >
                                              <g
                                                stroke='none'
                                                strokeWidth={1}
                                                fill='none'
                                                fillRule='evenodd'
                                              >
                                                <polygon points='0 0 24 0 24 24 0 24' />
                                                <path
                                                  d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                                  fill='#7950f2'
                                                  fillRule='nonzero'
                                                  transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                                />
                                              </g>
                                            </svg>
                                          </span>
                                        )}
                                      </span>
                                    </div>
                                    <div
                                      className='menu-item px-3'
                                      onClick={() => {
                                        dispatch(
                                          UpdateStatusForOwner({
                                            userId: data?._id,
                                            status2: 'suspended',
                                          })
                                        )
                                      }}
                                    >
                                      <span className='menu-link px-3'>
                                        <span className='bg-danger   rounded-circle border border-4 border-white h-20px w-20px'></span>
                                        <span className='menu-title'>Suspended</span>

                                        {data?.status2 == 'suspended' && (
                                          <span className='svg-icon svg-icon-primary'>
                                            <svg
                                              xmlns='http://www.w3.org/2000/svg'
                                              xmlnsXlink='http://www.w3.org/1999/xlink'
                                              width='24px'
                                              height='24px'
                                              viewBox='0 0 24 24'
                                              version='1.1'
                                            >
                                              <g
                                                stroke='none'
                                                strokeWidth={1}
                                                fill='none'
                                                fillRule='evenodd'
                                              >
                                                <polygon points='0 0 24 0 24 24 0 24' />
                                                <path
                                                  d='M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z'
                                                  fill='#7950f2'
                                                  fillRule='nonzero'
                                                  transform='translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002)'
                                                />
                                              </g>
                                            </svg>
                                          </span>
                                        )}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                              {/* begin::Menu item */}

                              {AuthenticateUser('delete-sub-account') && (
                                <div className='menu-item px-3'>
                                  <span
                                    className='menu-link px-3 text-danger m-0'
                                    data-kt-users-table-filter='delete_row'
                                    onClick={() => handleDelete(data?._id)}
                                  >
                                    Delete
                                  </span>
                                </div>
                              )}

                              {/* end::Menu item */}
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className='abcd '>
                  <select onChange={(e: any) => setPage({...page, size: e.target.value})}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                  </select>
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={Teams?.totalPages}
                    onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            </div>
          ) : (
            <NodataYet />
          )}
        </div>
      }
    </>
  )
}

export default TeamList
